var KlarnaHelper = (function (prePayment, afterPayment, getProductDetails) {

    var animationClass = 'processing-animation';

    var $payButtonEl;

    var pending = false;

    var _clientToken = null;

    var payment_method_category = 'pay_later';

    var _klarnaLoaded = new $.Deferred();

    var _klarnaUpdating = new $.Deferred();

    var _loadKlarna = function () {
        var script = document.createElement('script');
        script.src = 'https://x.klarnacdn.net/kp/lib/v1/api.js';
        if (document.head.append) {
            document.head.append(script);
        } else {
            document.head.appendChild(script);
        }
    }

    window.klarnaAsyncCallback = function () {
        _klarnaLoaded.resolve();
    };

    var _getButton = function() {
        return $.tmpl('klarna-button');
    };

    var _subscribe = function () {
        //$payButtonEl.attr('style', '');
        $payButtonEl.on('click', _clickHandler);
        $('@klarna-widget-background').click(function () {
            $('@klarna-widget-background').addClass('hidden-block');
            $('@klarna-widget').addClass('hidden-block');
        });
    }

    var _subscribePopup = function () {
        _clickHandlerPopup();
        $('@klarna-widget-background').click(function () {
            $('@klarna-widget-background').addClass('hidden-block');
            $('@klarna-widget').addClass('hidden-block');
        });
    }

    var _unsubscribe = function () {
        //$payButtonEl.attr('style', 'background-color:#f2f2f2!important');
        $payButtonEl.off('click');
    }

    var authorization_success = function (res) {

        if (window.app && app.event && app.event.klarnaCreateOrder) {
            app.event.klarnaCreateOrder();
        }

        api.createKlarnaOrder(res.authorization_token).done(function (result) {
            afterPayment(result);
        });
    }

    var _authorize = function (data) {
        var def = new $.Deferred();

        var _details = {
            billing_address: data.billingAddress,
            shipping_address: data.shippingAddress,
            order_lines: data.orderLines
        };

        $('#klarna-pay-later-fullscreen').css('display', 'block');
        try {

            if (window.app && app.event && app.event.klarnaAuthorize) {
                app.event.klarnaAuthorize();
            }

            Klarna.Payments.authorize({
                payment_method_category: payment_method_category
            }, _details,
            function(res) {
                if (res.approved && res.authorization_token) {
                    def.resolve(res);
                } else {
                    def.reject({ display_popup_widget: !res.approved && res.finalize_required === undefined});
                }
            });
        } catch (e) {
            def.reject({ display_popup_widget: false });
        }
        return def.promise();
    }

    var _finalize = function(authResult) {
        var def = new $.Deferred();

        if (authResult.finalize_required) {

            try {

                if (window.app && app.event && app.event.klarnaFinalize) {
                    app.event.klarnaFinalize();
                }

                Klarna.Payments.finalize({
                    payment_method_category: payment_method_category
                }, {},
                function(res) {
                    if (res.approved && res.authorization_token) {
                        def.resolve(res);
                    } else {
                        def.reject({ display_popup_widget: !res.approved && res.finalize_required === undefined });
                    }
                });
            } catch (e) {
                def.reject({ display_popup_widget: false });
            }

        } else {
            def.resolve(authResult);
        }

        return def.promise();
    }

    var _clickHandler = function (e) {
        e && e.preventDefault();
        if (prePayment && !pending) {
            pending = true;
            $payButtonEl.addClass(animationClass);

            if (window.app && app.event && app.event.klarnaButtonClick) {
                app.event.klarnaButtonClick();
            }

            prePayment()
                .then(_updateKlarnaWidget)
                .then(_authorize)
                .then(_finalize)
                .then(authorization_success)
                .fail(function (result) {
                    if (result && result.display_popup_widget) {
                        $('@klarna-widget').removeClass('hidden-block');
                        $('@klarna-widget-background').removeClass('hidden-block');
                        var height = $('#klarna-widget').height();
                        $('@klarna-widget').css('margin-top', '-' + height + 'px');
                    }
                }).always(function() {
                    $('#klarna-pay-later-fullscreen').css('display', 'none');
                    pending = false;
                    $payButtonEl.removeClass(animationClass);
                });
        }
    }

    var _clickHandlerPopup = function () {
        if (prePayment && !pending) {
            pending = true;

            if (window.app && app.event && app.event.klarnaButtonClick) {
                app.event.klarnaButtonClick();
            }

            prePayment()
                .then(_updateKlarnaWidget)
                .then(_authorize)
                .then(_finalize)
                .then(authorization_success)
                .fail(function (result) {
                    if (result && result.display_popup_widget) {
                        $('@klarna-widget').removeClass('hidden-block');
                        $('@klarna-widget-background').removeClass('hidden-block');
                        var height = $('#klarna-widget').height();
                        $('@klarna-widget').css('margin-top', '-' + height + 'px');
                    }
                }).always(function () {
                    $('#klarna-pay-later-fullscreen').css('display', 'none');
                    pending = false;
                });
        }
    }

    var _updateKlarnaWidget = function () {
        var def = new $.Deferred();

        _klarnaLoaded.done(function() {
            api.createKlarnaSession().then(function (data) {
                var _token = data.Value.token;
                var billingAddress = data.Value.klarnaSessionModel.billingAddress;
                var shippingAddress = data.Value.klarnaSessionModel.shippingAddress;
                var orderLines = data.Value.klarnaSessionModel.order_lines;

                try {
                    if (_clientToken !== _token) {
                        _clientToken = _token;
                        Klarna.Payments.init({
                            client_token: _clientToken
                        });
                    }

                    if (window.app && app.event && app.event.klarnaWidgetLoad) {
                        app.event.klarnaWidgetLoad();
                    }

                    Klarna.Payments.load({
                            container: '#klarna-widget',
                            payment_method_category: payment_method_category
                        },
                        function(res) {
                            if (res.show_form) {
                                def.resolve({
                                    billingAddress: billingAddress,
                                    shippingAddress: shippingAddress,
                                    orderLines: orderLines
                                });
                            }
                            def.reject();
                        });
                } catch (e) {
                    def.reject();
                }
            });

        });

        return def.promise();
    };

    _loadKlarna();

    return {
        appendTo: function($el, $tcEl) {
            var button = _getButton();
            $payButtonEl = button.find('@btnKlarna');
            button.appendTo($el);
            _subscribe();

            if ($tcEl && $tcEl.length) {
                $tcEl.html($.tmpl('klarna-tc-text')).removeClass('hidden-block');
            }

            return {
                update: function() {}
            }
        },

        replaceWith: function ($el, $tcEl) {
            var button = _getButton();
            $payButtonEl = button.find('@btnKlarna');
            $el.replaceWith(button);
            _subscribe();

            if ($tcEl && $tcEl.length) {
                $tcEl.html($.tmpl('klarna-tc-text')).removeClass('hidden-block');
            }

            return {
                update: function () { }
            }
        },

        buttonPopup: function () {
            _subscribePopup();

            return {
                update: function () { }
            }
        }
    }
});